import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { shouldSubmitSearch } from '../searchSubmit';
import { HeaderMoreMenu } from './HeaderMoreMenu';
import { ListingRequestForm } from './ListingRequestForm';
import { LogoMark } from './LogoMark';
import { SearchField } from './SearchField';
import { SiteFooter } from './SiteFooter';
import { PageHead } from './PageHead';
import './SearchResultsPage.css';
import './AboutPage.css';

export function ApplyProTrialPage() {
  const navigate = useNavigate();
  const [draftQuery, setDraftQuery] = useState('');

  function applySearch(query) {
    const trimmed = typeof query === 'string' ? query.trim() : '';
    if (!shouldSubmitSearch(trimmed)) {
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  }

  return (
    <div className="results-page">
      <PageHead
        title="Apply to list your store | Shops.mt"
        robots="noindex, follow"
      />
      <h1 className="sr-only">Apply to list your store on Shops.mt</h1>
      <header className="results-page__header">
        <div className="results-page__header-inner">
          <div className="results-page__header-left">
            <LogoMark variant="header" />
            <HeaderMoreMenu />
          </div>
          <div className="results-page__header-center">
            <SearchField
              id="apply-pro-trial-search"
              className="results-page__search search-bar"
              value={draftQuery}
              onChange={setDraftQuery}
              onSubmitSearch={applySearch}
              placeholder="Search products…"
            />
          </div>
          <nav
            className="results-page__header-nav"
            aria-label="Site sections"
          >
            <Link className="results-page__nav-link" to="/about">
              About
            </Link>
            <Link
              className="results-page__nav-link results-page__nav-link--current"
              to="/add-store"
              aria-current="page"
            >
              Add your store
            </Link>
          </nav>
        </div>
      </header>

      <div className="about-page">
        <section
          className="about-page__section"
          aria-labelledby="apply-form-heading"
        >
          <h2 id="apply-form-heading" className="about-page__title">
            Apply to list your store
          </h2>
          <p className="about-page__lede">
            Tell us about your shop and we&apos;ll review your application.
          </p>
          <ListingRequestForm />
        </section>
      </div>
      <SiteFooter />
    </div>
  );
}
